import styled from 'styled-components';
import BasicButton from '../Basic/BasicButton';

const SecondaryButton = styled(BasicButton)`
  background-color: var(--grey);
`;

export default SecondaryButton;
